module.exports = __webpack_public_path__ + "1cde8a8aedd5d62fcc74f23000f4d03f.svg";